export const preventSubmitOnEnter = (evt: React.KeyboardEvent<HTMLFormElement>) => {
  if (evt.key === 'Enter') {
    const target = evt.target as HTMLElement;
    // Allow Enter inside textarea
    if (target.tagName === 'TEXTAREA') {
      return;
    }
    // Prevent form submission for everything else
    evt.preventDefault();
  }
};
